export const getQueryResponseCachingRoute = () => {
  return '/settings/query-response-caching';
};
